import { DNSRecordType } from "../../api/partner/models/DNSZone";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCaretDown, faCertificate, faCogs, faEnvelopeOpen, faFileAlt, faGlobe, faLink, faLock, faServer, faShieldAlt } from "@fortawesome/free-solid-svg-icons";

export const RecordTypeSelect = ({ type, onTypeChange, allowRedirect, readonlyMode }: { type: DNSRecordType, onTypeChange: (newType: DNSRecordType) => void, allowRedirect: boolean, readonlyMode: boolean }) => {
  const icon = (type: DNSRecordType) => {
    switch (type) {
      case "A": return faGlobe
      case "AAAA": return faGlobe
      case "NS": return faServer
      case "MX": return faEnvelopeOpen
      case "CNAME": return faLink
      case "TXT": return faFileAlt
      case "REDIRECT": return faArrowRight
      case "CAA": return faCertificate
      case "SRV": return faCogs
      case "TLSA": return faShieldAlt
      case "HTTPS": return faLock
    }
  }
  const iconColor = (type: DNSRecordType) => {
    switch (type) {
      case "A": return 'bg-emerald-600 text-white'
      case "AAAA": return 'bg-emerald-600 text-white'
      case "NS": return 'bg-black text-white'
      case "MX": return 'bg-purple-600 text-white'
      case "CNAME": return 'bg-blue-600 text-white'
      case "TXT": return 'bg-slate-600 text-white'
      case "REDIRECT": return 'bg-amber-600 text-white'
      case "CAA": return 'bg-green-600 text-white'
      case "SRV": return 'bg-yellow-600 text-white'
      case "TLSA": return 'bg-teal-600 text-white'
      case "HTTPS": return 'bg-sky-600 text-white'
    }
  }
  const labelColor = (type: DNSRecordType) => {
    switch (type) {
      case "A": return 'text-emerald-700'
      case "AAAA": return 'text-emerald-700'
      case "NS": return 'text-black'
      case "MX": return 'text-purple-700'
      case "CNAME": return 'text-cyan-700'
      case "TXT": return 'text-slate-700'
      case "REDIRECT": return 'text-amber-700'
      case "CAA": return 'text-green-700'
      case "SRV": return 'text-yellow-700'
      case "TLSA": return 'text-teal-700'
      case "HTTPS": return 'text-sky-700'
    }
  }

  const description = (type: DNSRecordType) => {
    switch (type) {
      case "A": return 'Points a name to an IPv4 address.'
      case "AAAA": return 'Points a name to an IPv6 address.'
      case "NS": return 'Delegates a name to other nameservers.'
      case "MX": return 'Mail server that receives email for this domain.'
      case "CNAME": return 'Alias that points a name to another hostname.'
      case "TXT": return 'Free text, e.g. for SPF, DKIM or domain verification.'
      case "REDIRECT": return 'Forwards visitors to another URL.'
      case "CAA": return 'Which certificate authorities may issue SSL certificates.'
      case "SRV": return 'Location (host & port) of a specific service.'
      case "TLSA": return 'Pins a certificate for DANE, mostly used for mail servers.'
      case "HTTPS": return 'Advertises HTTP/3 & connection hints. Not needed for SSL.'
    }
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const selectRecord = (type: DNSRecordType) => {
    onTypeChange(type)
    setIsMenuOpen(false)
  }

  return <>
    <div className={`flex flex-row items-center border-2 border-white rounded-lg text-xs font-bold m-1 bg-slate-50 ${!readonlyMode && 'hover:bg-slate-200 cursor-pointer'}`} onClick={() => !readonlyMode && setIsMenuOpen(true)}>
      <div className={`${iconColor(type)} h-5 w-5 flex items-center justify-center rounded-sm m-1`}>
        <FontAwesomeIcon icon={icon(type)} className={"h-3 w-3"} />
      </div>
      <div className={`${labelColor(type)} mx-1 flex-1`}>
        {type}
      </div>
      {!readonlyMode && <div className={"flex items-center justify-center m-1"}>
        <FontAwesomeIcon icon={faCaretDown} className={"h-2 w-2 text-slate-500"} />
      </div>}

    </div>
    {isMenuOpen && <div className={"fixed top-0 left-0 w-full bg-black opacity-5 h-full"} onClick={() => setIsMenuOpen(false)}></div>}
    {isMenuOpen && <div className={"absolute z-10 top-9 left-2 w-56 bg-white border border-slate-200 rounded-lg shadow-lg"}>
      <span className={"block text-xs font-bold text-slate-500 uppercase m-3 mb-0"}>Change record type</span>
      {(["A", "AAAA", "MX", "CNAME", "TXT", "CAA", "SRV", "TLSA", "HTTPS", ...(allowRedirect ? ["REDIRECT"] : [])] as DNSRecordType[]).map((t, k) => <div key={k} className={`flex flex-row items-center rounded-lg border text-xs font-bold m-2 ${t === type ? "border-slate-300" : "border-transparent"} hover:bg-slate-100 cursor-pointer`} onClick={() => selectRecord(t)}>
        <div className={`${iconColor(t)} h-6 w-6 flex items-center justify-center rounded-sm m-1`}>
          <FontAwesomeIcon icon={icon(t)} className={"h-4 w-4"} />
        </div>
        <div className={`text-black mx-1 flex-1`}>
          {t}
          {description(t) && <span className={"block text-[10px] font-normal text-slate-500 leading-tight"}>{description(t)}</span>}
        </div>
      </div>)}
    </div>}
  </>
}
